import { combineReducers } from '@reduxjs/toolkit';
import { ProfileReducer } from '@common/store/profiles/profile-reducer';
import usageDataBatchesReducer from './usage-data-current-batch';
import usageUsageDataHistoryReducer from './usage-data-history';
export const rootReducer = combineReducers({
    usageDataCurrentBatch: usageDataBatchesReducer,
    usageDataHistory: usageUsageDataHistoryReducer,
    profileReducer: ProfileReducer
});
